import { render, staticRenderFns } from "./ClientProfileFinancial.vue?vue&type=template&id=3181190b"
import script from "./ClientProfileFinancial.vue?vue&type=script&lang=js"
export * from "./ClientProfileFinancial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports